<template>
  <div :class="{ 'has-error': validacao.$error }" class="form-group">
    <label v-if="exibeLabel">
      {{ label }} <sup>{{ labelSup }}</sup>
    </label>
    <input
      :id="id"
      v-mask="'999.999.999-99'"
      :data-test-id="`input-${id}`"
      :name="id"
      :placeholder="placeholder"
      :readonly="somenteLeitura"
      :value="valor"
      type="text"
      class="form-control"
      @input="atualizar"
    />
    <div v-if="validacao.$dirty" class="help-block">
      <slot name="mensagensValidacao" />
    </div>
  </div>
</template>

<script>
import AwesomeMask from 'awesome-mask'

import { campoMixin } from '@/mixins/CampoMixin'

export default {
  name: 'CampoCpf',
  directives: { mask: AwesomeMask },
  mixins: [campoMixin],
  props: {
    label: {
      type: String,
      default: 'CPF',
    },
    id: {
      type: String,
      default: 'cpf',
    },
    placeholder: {
      type: String,
      default: 'CPF',
    },
  },
  methods: {
    atualizar(evento) {
      if (!evento.target || !evento.target.value) return
      const valor = evento.target.value

      if (typeof valor !== 'undefined' && valor.length === 14) {
        const cpf = valor.replace(/\./g, '').replace(/-/g, '')
        this.$emit('atualizar', cpf)
        this.validacao.$touch()
      }
    },
  },
}
</script>
